import QUERYKEYS from '../../../constants/queryKeys';
import type { TQueryModel } from '../../../utils/hookUtils';
import type { TVendorCodeCommercialHomeWarranty } from './../../../models/vendor/VendorCodeModels';
import { getVendorCodeCommercialHomeWarranty } from './../../../services/VendorCodesService';
import { useQuery } from 'react-query';

function useVendorCodeCommercialHomeWarranty(
  vendorCodeId: string,
): TQueryModel<TVendorCodeCommercialHomeWarranty> {
  const { isLoading, isError, data } = useQuery(
    [QUERYKEYS.VENDOR_CODES_COMMERCIAL_HOME_WARRANTY, vendorCodeId],
    () => getVendorCodeCommercialHomeWarranty(vendorCodeId),
  );

  return {
    data,
    isError,
    isLoading,
  };
}

export default useVendorCodeCommercialHomeWarranty;
